//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { messageAnswerAddAndEdit as _messageAnswerAddAndEdit, getServeLeaveMessageInfo as _getServeLeaveMessageInfo } from "@/api/managementCenter/advices";
export default {
  name: "answerMsgDialog",
  components: {},
  props: [],
  data: function data() {
    return {
      data: {},
      type: "",
      show: false,
      loading: false,
      msgList: [],
      form: {},
      param: {}
    };
  },
  computed: {},
  methods: {
    // 显示弹框
    dialogShow: function dialogShow(type, data) {
      var _this = this;

      this.type = type;
      this.data = data;
      this.show = true;
      this.$nextTick(function () {
        _this.getServeLeaveMessageInfo();
      }); // this.$nextTick(()=>{
      //     this.param={msgId:data.msgId};
      //     this.form.msgId = data.msgId
      //     this.form.serveId = data.serveId
      //     this.form.answerBy = this.$store.getters.userData.userName
      //     this.nowTime =utils.dateFormat((new Date()).getTime());
      //     this.getLeaveMsgDetail()
      // })
    },
    getServeLeaveMessageInfo: function getServeLeaveMessageInfo() {
      var _this2 = this;

      this.loading = true;

      _getServeLeaveMessageInfo(this.data.id).then(function (_ref) {
        var data = _ref.data;
        _this2.loading = false;

        if (data.code == 0) {
          _this2.form = data.data || {};

          _this2.$nextTick(function () {// let container = this.$el.querySelector(".msg-detail");
            // container.scrollTop = container.scrollHeight;
          });
        } else {
          _this2.$message.warning(data.msg || "获取留言信息失败！");
        }
      }).catch(function (err) {
        _this2.loading = false;
      });
    },
    messageAnswerAddAndEdit: function messageAnswerAddAndEdit() {
      var _this3 = this;

      this.loading = true;
      var params = {
        content: this.form.contents,
        msgId: this.data.id,
        serveId: this.data.serveId
      };

      _messageAnswerAddAndEdit(params).then(function (_ref2) {
        var data = _ref2.data;
        _this3.loading = false;

        if (data.code == 0) {
          _this3.$message.success("回复成功!");

          _this3.$emit("saveSuccess");

          _this3.getServeLeaveMessageInfo();
        } else {
          _this3.$message.warning(data.msg || "回复失败!");
        }
      }).catch(function (err) {
        _this3.loading = false;

        _this3.$message.error("服务器异常!");
      });
    },
    // 确定提交
    submitForm: function submitForm(formName) {
      if (!this.form.contents) {
        this.$message.warning("请输入要回复的内容!");
        return;
      }

      this.messageAnswerAddAndEdit();
    }
  },
  watch: {
    show: function show(val) {
      if (!val) {
        this.form.contents = "";
      }
    }
  },
  filters: {}
};